const EMBEDDED_APP_REGEX = /.*\/oauth\/[0-9]*\/embedded\/.*/;
const isEmbedded = EMBEDDED_APP_REGEX.test(window.location.pathname);
export default isEmbedded;